module.exports = __webpack_public_path__ + "static/class-notes-hero-f7572fd37acacbac9de7e2bc9299291f.jpg";